/**
 * Default Preservoir management-fee rate, in PERCENT per annum (0.3 = 0.3%/yr).
 * Used only as the mapper fallback when the API omits the client's rate — the
 * server-side entity default is the source of truth (bug preservoir-client#75).
 */
export const DEFAULT_CHARGE_RATE_PER_ANNUM = 0.3;

export interface CorporateEntitySummary {
  id: string;
  name: string;
  registrationNumber: string;
  type?: CorporateEntityType; // Assuming type is a string, adjust as necessary
  /**
   * The client's management-fee rate in PERCENT per annum (0.3 = 0.3%/yr).
   * Non-optional: corporateEntityMapper.summaryFromApi is the single choke point
   * that resolves fallback/clamping, so consumers never see undefined.
   */
  chargeRatePerAnnum: number;
}

export enum CorporateEntityType {
  Business = 'Business',
  Charity = 'Charity',
}

export interface AssetSummary {
  totalValue: number;
  totalCount: number;
  activeAssets: number;
  maturedAssets: number;
  pendingAssets: number;
}
